import { createApp } from "vue"
import GeneralOverview from "./GeneralOverview.vue"

const app = createApp(GeneralOverview)
app.mount("#overview")
